import React, {Component} from 'react';
import './Footer.css';

class Footer extends Component {


    render() {
        const currentYear = new Date().getFullYear();

        return (
            <div className="footer row">
                <p className="copyright"><i className="fa fa-copyright"/> Emmanuelle Claeys - {currentYear}</p>
            </div>
        );

    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Components/Footer/Footer.js